module.exports = __webpack_public_path__ + "static/map-4d57ae2462de7d8ba9a7341223ec2672.svg";